let shouldViewAllButtonsBeUnderlineStyle = true;

function changeViewAllButtonsToUnderlineStyle() {
  let newSvg = createSVG();

  // Define child (anchor tag)
  let anchorTag = i.childNodes[1];

  // Get inner text from existing button
  let btnInnerText = anchorTag.innerText;

  // Create label element
  let labelSpan = document.createElement('span');
  labelSpan.classList.add('label');
  labelSpan.innerText = btnInnerText;

  console.log(labelSpan);

  // Clear existing innerText from DOM
  anchorTag.innerText = '';

  // Add span to DOM
  anchorTag.appendChild(labelSpan);
  anchorTag.appendChild(newSvg);

  // add class to button
  let classesToAdd = ['button--cta', 'focus-inset']
  anchorTag.classList.add(...classesToAdd);
}

function createSVG() {
  let svgSelector = document.querySelector('.button--cta svg');
  let pathSelector = document.querySelector('.button--cta svg path');
  console.log(svgSelector);

  // create svg
  let svgElem = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
  let pathElem = document.createElementNS("http://www.w3.org/2000/svg", 'path');
  svgElem.appendChild(pathElem);

  // get properties of svg
  let svgProperties = {
    xmlns: svgSelector.getAttribute('xmlns'),
    aria: svgSelector.getAttribute('aria-hidden'),
    focusable: svgSelector.getAttribute('focusable'),
    class: svgSelector.classList,
    fill: svgSelector.getAttribute('fill'),
    viewBox: svgSelector.getAttribute('viewBox'),
  }

  let pathProperties = {
    'fill-rule': pathSelector.getAttribute('fill-rule'),
    'clip-rule': pathSelector.getAttribute('clip-rule'),
    d: pathSelector.getAttribute('d'),
    fill: pathSelector.getAttribute('fill')
  }

  // Loop through properties and create them on the new svg
  for (let [key, value] of Object.entries(svgProperties)) {
    if (key == 'xmlns') {
      svgElem.setAttributeNS("http://www.w3.org/2000/xmlns/", 'xmlns:xlink', "http://www.w3.org/1999/xlink");
    }
    svgElem.setAttribute(key, value);
  }

  for (let [key, value] of Object.entries(pathProperties)) {
    pathElem.setAttribute(key, value);
  }

  return svgElem;
}

if (shouldViewAllButtonsBeUnderlineStyle == true) {
  // Select all containers
  let btnContainer = document.querySelectorAll('.view-all.center');

  for (i of btnContainer) {
    changeViewAllButtonsToUnderlineStyle(i)
  };
}

// Judge.me Histogram Classes
let hasRun = false;

const observer = new MutationObserver((mutations) => {
  if (hasRun) return;
  const histogram = document.querySelector('.jm-histogram:not(.jdgm-temp-hidden)');

  if (histogram) {
    const histogramRows = document.querySelectorAll('.jm-histogram-row');

    if (histogramRows.length > 0) {
      hasRun = true;
      console.log('App found with visible content');
      observer.disconnect();
      toggleSelectedClass(histogram, histogramRows);
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});

function addClearFiltersButton(item, list) {
  let clearFiltersButton = document.getElementById('rk-button__clear-filters');
  if (!clearFiltersButton) {
    clearFiltersButton = document.createElement('p');
    clearFiltersButton.setAttribute('id', "rk-button__clear-filters");
    clearFiltersButton.innerText = "✕";
    item.appendChild(clearFiltersButton);
  }

  clearFiltersButton.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const selectedRow = Array.from(list).find(row => row.classList.contains('rk-selected'));

    if (selectedRow) selectedRow.click();

    console.log(`Clicked clear filters button.`);
    for (const row of list) {
      row.classList.remove('rk-selected');
      console.log('Class removed from:', row);
    }
    removeClearFiltersButton()
  })
}

function removeClearFiltersButton() {
  let button = document.getElementById('rk-button__clear-filters');
  if (button) {
    button.remove();
  }
}

function toggleSelectedClass(block, list) {
  for (const item of list) {
    item.addEventListener('click', (e) => {
      const wasSelected = item.classList.contains('rk-selected');

      for (const row of list) {
        row.classList.remove('rk-selected');
        removeClearFiltersButton();
      }

      if (wasSelected) {
        return;
      }
      item.classList.add('rk-selected');
      console.log('Class added to:', item);
      addClearFiltersButton(item, list);
    });
  }
}

// START Function for adding metaobject values into pages, including dynamic insertions
document.addEventListener('page:loaded', function () {
  // Page has loaded and theme assets are ready
  const contentOnPage = document.querySelector('.rk-insert-metaobjects');
  const regexForDynamicMetaobjectContent = /\[\[\s*(.*?)\s*\]\]/g;

  function replaceDynamicPlaceholdersWithMetaobjectValues() {
    return contentOnPage.innerHTML.replace(regexForDynamicMetaobjectContent, (fullMatch, key) => {
      if (configSettings[key.trim()] !== undefined) {
        return configSettings[key.trim()];
      }
      return fullMatch;
    });
  }
  function getAllDynamicMetaobjectPlaceholdersInContent() {
    return [...contentOnPage.innerHTML.matchAll(regexForDynamicMetaobjectContent)].map((match) => ({
      name: match[1],
      full: match[0],
    }));
  }

  if (contentOnPage) {
    getAllDynamicMetaobjectPlaceholdersInContent();
    contentOnPage.innerHTML = replaceDynamicPlaceholdersWithMetaobjectValues();
  } else {
  }
});

// Badges at variant-level on PDP and PLPs using metaobjects
(() => {
  const PLP_BADGE_SELECTOR = "[data-promotion-badge]";
  const PDP_ROOT_SELECTOR = "[data-variant-promotion-root]";
  const PRODUCT_SECTION_SELECTOR = '[id^="shopify-section-"]';

  const CHECK_INTERVAL = 30000;
  const MARKUP_SETTLE_DELAY = 50;

  /*
   * Shared date handling
   */

  function parsePromotionDate(value) {
    if (!value) return null;

    const timestamp = Date.parse(value);

    return Number.isFinite(timestamp)
      ? timestamp
      : null;
  }

  function promotionDatesAreActive(
    startsAtValue,
    endsAtValue
  ) {
    const startsAt =
      parsePromotionDate(startsAtValue);

    const endsAt =
      parsePromotionDate(endsAtValue);

    if (startsAt === null || endsAt === null) {
      return false;
    }

    if (endsAt <= startsAt) {
      return false;
    }

    const now = Date.now();

    return now >= startsAt && now < endsAt;
  }

  /*
   * PLP promotion badges
   */

  function plpPromotionIsActive(badge) {
    const enabled =
      badge.dataset.promotionEnabled === "true";

    if (!enabled) {
      return false;
    }

    return promotionDatesAreActive(
      badge.dataset.promotionStartsAt,
      badge.dataset.promotionEndsAt
    );
  }

  function updatePlpPromotionBadge(badge) {
    const active =
      plpPromotionIsActive(badge);

    badge.hidden = !active;

    badge.setAttribute(
      "aria-hidden",
      String(!active)
    );
  }

  function updatePlpPromotionBadges(
    root = document
  ) {
    root
      .querySelectorAll(PLP_BADGE_SELECTOR)
      .forEach(updatePlpPromotionBadge);
  }

  /*
   * PDP promotion data
   */

  function getVariantPromotionData(root) {
    if (root._variantPromotionData) {
      return root._variantPromotionData;
    }

    const dataElement = root.querySelector(
      "[data-variant-promotion-data]"
    );

    if (!dataElement) {
      return null;
    }

    try {
      root._variantPromotionData = JSON.parse(
        dataElement.textContent
      );

      return root._variantPromotionData;
    } catch (error) {
      console.error(
        "Unable to parse variant promotion data.",
        error
      );

      return null;
    }
  }

  function variantPromotionIsActive(promotion) {
    if (!promotion) {
      return false;
    }

    if (promotion.enabled !== true) {
      return false;
    }

    if (!promotion.badgeText) {
      return false;
    }

    return promotionDatesAreActive(
      promotion.startsAt,
      promotion.endsAt
    );
  }

  /*
   * PDP badge rendering
   */

  function updateVariantPromotionForRoot(
    root,
    variantId
  ) {
    if (!root || !variantId) {
      return;
    }

    const badge = root.querySelector(
      "[data-variant-promotion-badge]"
    );

    const textElement = root.querySelector(
      "[data-variant-promotion-text]"
    );

    const promotionData =
      getVariantPromotionData(root);

    if (
      !badge ||
      !textElement ||
      !promotionData
    ) {
      return;
    }

    const normalisedVariantId =
      String(variantId);

    const promotion =
      promotionData[normalisedVariantId];

    /*
     * Remember the current variant so the timed
     * recheck uses the correct selection.
     */
    root.dataset.currentVariantId =
      normalisedVariantId;

    if (!variantPromotionIsActive(promotion)) {
      badge.hidden = true;

      badge.setAttribute(
        "aria-hidden",
        "true"
      );

      textElement.textContent = "";

      return;
    }

    textElement.textContent =
      promotion.badgeText;

    if (promotion.background) {
      badge.style.setProperty(
        "--color-badge-background",
        promotion.background
      );

      badge.style.setProperty(
        "--color-badge-border",
        promotion.background
      );
    } else {
      badge.style.removeProperty(
        "--color-badge-background"
      );

      badge.style.removeProperty(
        "--color-badge-border"
      );
    }

    if (promotion.textColour) {
      badge.style.setProperty(
        "--color-badge-foreground",
        promotion.textColour
      );
    } else {
      badge.style.removeProperty(
        "--color-badge-foreground"
      );
    }

    badge.hidden = false;

    badge.setAttribute(
      "aria-hidden",
      "false"
    );
  }

  /*
   * Read the selected variant ID from the Shopify
   * add-to-cart form inside the product section.
   */

  function getCurrentVariantId(section) {
    if (!section) {
      return null;
    }

    const variantInput = section.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    return variantInput?.value || null;
  }

  function updatePromotionFromSection(section) {
    if (!section) {
      return;
    }

    const root = section.querySelector(
      PDP_ROOT_SELECTOR
    );

    if (!root) {
      return;
    }

    const variantId =
      getCurrentVariantId(section) ||
      root.dataset.currentVariantId ||
      root.dataset.initialVariantId;

    if (!variantId) {
      return;
    }

    updateVariantPromotionForRoot(
      root,
      variantId
    );
  }

  function initialiseVariantPromotionBadges() {
    document
      .querySelectorAll(PDP_ROOT_SELECTOR)
      .forEach((root) => {
        const section = root.closest(
          PRODUCT_SECTION_SELECTOR
        );

        if (section) {
          updatePromotionFromSection(section);
          return;
        }

        const variantId =
          root.dataset.currentVariantId ||
          root.dataset.initialVariantId;

        updateVariantPromotionForRoot(
          root,
          variantId
        );
      });
  }

  /*
   * Variant option listener
   *
   * This listener has already been confirmed to fire
   * correctly in this version of Be Yours.
   */

  document.addEventListener(
    "change",
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const variantPicker =
        event.target.closest("variant-selects");

      if (!variantPicker) {
        return;
      }

      const productSection =
        variantPicker.closest(
          PRODUCT_SECTION_SELECTOR
        );

      if (!productSection) {
        return;
      }

      /*
       * Let Be Yours update its hidden variant ID
       * before reading it.
       */
      window.setTimeout(() => {
        updatePromotionFromSection(
          productSection
        );
      }, 0);
    },
    true
  );

  /*
   * Be Yours can replace product information after
   * the option change event. This observer updates
   * the newly inserted promotion badge.
   */

  const promotionMarkupObserver =
    new MutationObserver((mutations) => {
      const affectedSections = new Set();

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          /*
           * Ignore text changes made when the promotion
           * badge copy itself is updated.
           */
          if (!(node instanceof Element)) {
            return;
          }

          const parentSection = node.closest(
            PRODUCT_SECTION_SELECTOR
          );

          if (
            parentSection &&
            parentSection.querySelector(
              PDP_ROOT_SELECTOR
            )
          ) {
            affectedSections.add(
              parentSection
            );
          }

          if (
            node.matches(
              PRODUCT_SECTION_SELECTOR
            ) &&
            node.querySelector(
              PDP_ROOT_SELECTOR
            )
          ) {
            affectedSections.add(node);
          }

          node
            .querySelectorAll(
              PRODUCT_SECTION_SELECTOR
            )
            .forEach((section) => {
              if (
                section.querySelector(
                  PDP_ROOT_SELECTOR
                )
              ) {
                affectedSections.add(
                  section
                );
              }
            });
        });
      });

      affectedSections.forEach((section) => {
        window.setTimeout(() => {
          updatePromotionFromSection(section);
        }, MARKUP_SETTLE_DELAY);
      });
    });

  /*
   * Shared initialisation
   */

  function initialisePromotionBadges() {

    updatePlpPromotionBadges(document);
    initialiseVariantPromotionBadges();
  }

  function startPromotionBadges() {
    initialisePromotionBadges();

    promotionMarkupObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startPromotionBadges,
      { once: true }
    );
  } else {
    startPromotionBadges();
  }

  /*
   * Recheck PLP badges after collection filtering
   * or sorting.
   */

  document.addEventListener(
    "collection:reloaded",
    initialisePromotionBadges
  );

  /*
   * Make future promotions appear and expired
   * promotions disappear while the page remains open.
   */

  window.setInterval(
    initialisePromotionBadges,
    CHECK_INTERVAL
  );
})();


document.addEventListener(
  "change",
  (event) => {
    const variantPicker = event.target.closest(
      "variant-selects"
    );

    if (!variantPicker) return;

    window.setTimeout(() => {
      const productSection = variantPicker.closest(
        '[id^="shopify-section-"]'
      );

      if (!productSection) return;

      console.log("Variant picker changed", {
        variantId,
        variantInput
      });

      if (!variantId) return;

    }, 0);
  },
  true
);